import React from "react";
import {format} from "date-fns";
import {utcToZonedTime} from "date-fns-tz";
import {TimeZones} from "../../../shared/enums/timeZones";

export interface IEventTimeAndDateFormatProps {
  timeAndDate?: Date | null;
  endTime?: Date | null;
  timeZone?: string;
  isEndTimeVisible?: boolean;
}

// This atom is for displaying time like "Monday, 16 August 2021 at 12:39 pm"
const EventTimeAndDateFormat: React.FC<IEventTimeAndDateFormatProps> = ({
  timeAndDate,
  endTime,
  timeZone = TimeZones.Auckland,
  isEndTimeVisible = true
}) => {
  const startDate =
    timeAndDate &&
    format(
      utcToZonedTime(timeAndDate, timeZone),
      "EEEE, d MMM yyyy 'at' hh:mm aaa"
    );
  const endDate =
    endTime && isEndTimeVisible && timeAndDate
      ? " - " +
        format(
          utcToZonedTime(endTime, timeZone),
          timeAndDate.getDate() === endTime.getDate()
            ? "hh:mm aaa"
            : "EEEE, d MMM yyyy 'at' hh:mm aaa"
        )
      : "";

  return <span>{startDate + endDate}</span>;
};

export default EventTimeAndDateFormat;
